<template>
  <v-card-round :color="color" :elevation="elevation" :hover="hover" :ripple="ripple">
    <!-- Content -->
    <v-container fluid>
      <!-- First row with the image and the text content -->
      <v-layout wrap align-center>
        <!-- Image of the product -->
        <v-flex xs12 sm3 md2>
          <v-img :src="product.image || defaultImage" height="120px" contain />
        </v-flex>
        <!-- Text content -->
        <v-flex class="font-weight-light">
          <!-- Brand -->
          <v-layout class="grey--text subheading">
            <v-flex>{{ product.brand }}</v-flex>
          </v-layout>
          <!-- Name -->
          <v-layout class="blue-grey--text text--darken-5 title">
            <v-flex>
              <v-selectable-text :product="product" data="name" :dataId="product.nameId" />
            </v-flex>
          </v-layout>
          <!-- TODO: Description -->
          <!-- TODO: Specs -->
        </v-flex>
      </v-layout>
    </v-container>
  </v-card-round>
</template>

<script>
import defaultImage from "@/assets/placeholder.png";

import VCardRound from "@/components/cards/CardRound.vue";
import VSelectableText from "./ProductCardSelectableText.vue";

/**
 * A component that renders a card with the given product in a row format with
 * more information and the image at the left side.
 *
 * It triggers the events that indicate that a text was selected on any part of
 * the card with an object like `{string, section, offset, product}` with:
 * - string: the string selected.
 * - section: could be:
 *   - 'brand'
 *   - 'name'
 *   - 'description'
 *   - 'specs'
 * - offset: the number of character that the selected text is ahead in the section.
 * - product: this product.
 */
export default {
  components: {
    VCardRound,
    VSelectableText
  },
  props: {
    /**
     * The product to show in this card.
     * This component will use the name, brand of the product and optionally (only
     * if they are present) the image, description, specs and url of the product.
     */
    product: {
      type: Object,
      required: true
    },
    /**
     * The color of the card.
     */
    color: {
      type: String
    },
    /**
     * The elevation of the card.
     */
    elevation: {
      type: Number,
      default: 0
    },
    /**
     * Elevate the card on hover.
     */
    hover: {
      type: Boolean,
      default: false
    },
    /**
     * Apply the ripple directive on the card.
     */
    ripple: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    defaultImage
  })
};
</script>
